export default __webpack_public_path__ + "static/media/talks1.54e75f34.png";